import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(Path, { d: "M12 17.8 5.8 21 7 14.1 2 9.3l7-1L12 2", stroke: `${color}` })
    }
  );
};
Icon.displayName = "StarHalf";
const StarHalf = memo(themed(Icon));
export {
  StarHalf
};
//# sourceMappingURL=star-half.js.map
